var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappDarkFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6596 12.4304C22.6596 18.0788 18.0807 22.6577 12.4324 22.6577C10.2779 22.6577 8.27913 21.9915 6.63064 20.854L3.13483 21.7279L4.0509 18.2927C2.88768 16.6327 2.20508 14.6113 2.20508 12.4304C2.20508 6.78203 6.78398 2.20312 12.4324 2.20312C18.0807 2.20312 22.6596 6.78203 22.6596 12.4304Z",
    fill: "url(#paint0_linear_6073_8332)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4318 24.3636C19.0216 24.3636 24.3636 19.0216 24.3636 12.4318C24.3636 5.84206 19.0216 0.5 12.4318 0.5C5.84206 0.5 0.5 5.84206 0.5 12.4318C0.5 14.5718 1.06335 16.5802 2.04984 18.3167L0.5 24.3636L6.73426 22.918C8.42731 23.8399 10.3684 24.3636 12.4318 24.3636ZM12.4318 22.528C18.0078 22.528 22.528 18.0078 22.528 12.4318C22.528 6.85587 18.0078 2.33566 12.4318 2.33566C6.85587 2.33566 2.33566 6.85587 2.33566 12.4318C2.33566 14.5847 3.00952 16.5802 4.15782 18.2189L3.2535 21.6101L6.70449 20.7474C8.33184 21.8704 10.305 22.528 12.4318 22.528Z",
    fill: "#02000A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4487 6.89551C9.16501 6.3257 8.72982 6.37614 8.29017 6.37614C7.50445 6.37614 6.2793 7.31729 6.2793 9.06886C6.2793 10.5044 6.91185 12.0757 9.04336 14.4264C11.1004 16.6949 13.8033 17.8685 16.0472 17.8285C18.291 17.7886 18.7527 15.8576 18.7527 15.2055C18.7527 14.9165 18.5733 14.7723 18.4498 14.7331C17.6851 14.3661 16.2748 13.6824 15.9539 13.5539C15.633 13.4254 15.4655 13.5992 15.3613 13.6937C15.0703 13.971 14.4935 14.7883 14.296 14.9721C14.0985 15.156 13.804 15.0629 13.6815 14.9934C13.2306 14.8125 12.008 14.2687 11.0335 13.324C9.82822 12.1556 9.75749 11.7537 9.53042 11.3959C9.34876 11.1096 9.48207 10.934 9.54858 10.8572C9.80826 10.5576 10.1668 10.095 10.3276 9.86514C10.4884 9.63526 10.3608 9.28624 10.2842 9.06886C9.95474 8.13396 9.67566 7.35135 9.4487 6.89551Z",
    fill: "#02000A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6073_8332",
    x1: 12.4324,
    y1: 2.20312,
    x2: 12.4324,
    y2: 22.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappDarkFinal);
export default __webpack_public_path__ + "static/media/whatsapp-dark-final.c6cf7088224578bd413980322154124d.svg";
export { ForwardRef as ReactComponent };